import { useEffect } from 'react';

export function useListenToMessage<T>(
  callback: (event: any) => void,
  eventType?: T
) {
  useEffect(() => {
    if (!window?.addEventListener) {
      return;
    }

    const handler = (event: any) => {
      if (eventType && event?.data?.type !== eventType) {
        return;
      }
      callback(event);
    };

    window.addEventListener('message', handler);

    return () => {
      window.removeEventListener('message', handler);
    };
  }, [callback, eventType]);
}
